import cmsOneLabel from "./oneLabel/oneLabel.vue";
import cmsNavBar from "./navBar/navBar.vue";
// import cmsSys from "./showVideo/showVideo.vue";
import cmsVideo from "./video/cmsVideo.vue";
import cmsFileTable from "./cmsFileTableCanEdit/cmsFileTableCanEdit";
import cmsUploadFile from "./cmsUploadFile/cmsUploadFile.vue";
import audit from "./audit/audit.vue";
import multiplePicker from "./multiplePicker/multiplePicker.vue";
import treeSelect from "./treeSelect/treeSelect.vue";
import cmsPicker from "./cmsPicker/index.vue";
import datePicker from "./cmsPicker/datePicker.vue";

const cmsComponents = {
    install: function (Vue) {
        Vue.component('cmsOneLabel', cmsOneLabel);  //
        Vue.component('cmsNavBar', cmsNavBar);  //
        Vue.component('cmsNavBar', cmsNavBar);  //
        // Vue.component('cmsSys', cmsSys);  //
        Vue.component('cmsVideo', cmsVideo);  //
        Vue.component('cmsFileTable', cmsFileTable);  //
        Vue.component('cmsUploadFile', cmsUploadFile);  //
        Vue.component('cmsAudit', audit);  //
        Vue.component('multiplePicker', multiplePicker);  //
        Vue.component('treeSelect', treeSelect);  //
        Vue.component('cmsPicker', cmsPicker);  //
        Vue.component('datePicker', datePicker);  //
    }
}

// 导出组件
export default cmsComponents



// WEBPACK FOOTER //
// ./src/cmscomponents/index.js